import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const AuthDebugger = () => {
  const [authInfo, setAuthInfo] = useState<any>(null);

  useEffect(() => {
    const checkAuth = async () => {
      // Get current session
      const { data: sessionData } = await supabase.auth.getSession();
      
      // Check if is_admin_user function works
      let isAdminResult = null;
      try {
        const { data, error } = await supabase.rpc('is_admin_user');
        isAdminResult = { data, error: error?.message };
      } catch (err) {
        isAdminResult = { error: 'Function call failed' };
      }

      setAuthInfo({
        session: sessionData.session ? {
          user_id: sessionData.session.user.id,
          email: sessionData.session.user.email,
          hasSession: true
        } : { hasSession: false },
        isAdminFunction: isAdminResult,
        timestamp: new Date().toISOString()
      });
    };

    checkAuth();
    
    // Set up listener for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      checkAuth();
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle className="text-sm">🔍 Auth Debug Info</CardTitle>
      </CardHeader>
      <CardContent>
        <pre className="text-xs bg-gray-100 p-2 rounded overflow-auto">
          {JSON.stringify(authInfo, null, 2)}
        </pre>
      </CardContent>
    </Card>
  );
};